<template>
  <div class="plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <ul>
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <div class="qi">{{ el.qiShu }}期澳门码神六肖十码</div>
        <div class="value">
          <div class="code">
            <span>{{ el.qiShu }}期四肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.sx4"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
            <div class="kaijiang">
              开 {{ el.ifZuiXin ? "??" : el.shengXiao }}
              {{ el.ifZuiXin ? "??" : el.code }}
            </div>
          </div>
          <div class="code">
            <span>{{ el.qiShu }}期三肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.sx3"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
            <div class="kaijiang">
              开 {{ el.ifZuiXin ? "??" : el.shengXiao }}
              {{ el.ifZuiXin ? "??" : el.code }}
            </div>
          </div>
          <div class="code">
            <span>{{ el.qiShu }}期二肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.sx2"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
            <div class="kaijiang">
              开 {{ el.ifZuiXin ? "??" : el.shengXiao }}
              {{ el.ifZuiXin ? "??" : el.code }}
            </div>
          </div>
          <div class="code">
            <span>{{ el.qiShu }}期一肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.sx1"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
            <div class="kaijiang">
              开 {{ el.ifZuiXin ? "??" : el.shengXiao }}
              {{ el.ifZuiXin ? "??" : el.code }}
            </div>
          </div>
          <div class="code">
            <span>四字爆特</span>
            <div>
              <span
                :class="{
                  win: el.siZiBaoTe.includes(el.shengXiao) && !el.ifZuiXin,
                }"
                >{{ el.siZiBaoTe }}</span
              >
            </div>
            <div class="kaijiang">
              开 {{ el.ifZuiXin ? "??" : el.shengXiao }}
              {{ el.ifZuiXin ? "??" : el.code }}
            </div>
          </div>
          <div class="code">
            <span>③码中特</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.code3"
                :key="codeIndex"
                :class="{ win: code === el.code }"
                >{{ code }}</span
              >
            </div>
            <div class="kaijiang">
              开 {{ el.ifZuiXin ? "??" : el.shengXiao }}
              {{ el.ifZuiXin ? "??" : el.code }}
            </div>
          </div>
          <div class="code">
            <span>⑤码中特</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.code5"
                :key="codeIndex"
                :class="{ win: code === el.code }"
                >{{ code }}</span
              >
            </div>
            <div class="kaijiang">
              开 {{ el.ifZuiXin ? "??" : el.shengXiao }}
              {{ el.ifZuiXin ? "??" : el.code }}
            </div>
          </div>
          <div class="code">
            <span>⑩码中特</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.code10"
                :key="codeIndex"
                :class="{ win: code === el.code }"
                >{{ code }}</span
              >
            </div>
            <div class="kaijiang">
              开 {{ el.ifZuiXin ? "??" : el.shengXiao }}
              {{ el.ifZuiXin ? "??" : el.code }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
    
    <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);

data.value?.list.forEach((item, index) => {
  data.value.list[index] = {
    ...item,
    ...item.yuCe,
  };
});
</script>
    
    <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
.plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background-image: linear-gradient(to bottom, #b4b9b1, #f1edeb);
    padding: 3px 0;
    border-top: 2px solid #767474;
    border-bottom: 2px solid #767474;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      //   padding: 5px 12px;
      padding: 0;
      font-weight: bold;
      //   display: flex;
      justify-content: center;
      .qi {
        border-bottom: 1px solid #ccc;
        padding: 6px 0;
        background-color: #0d35f4;
        color: #fff;
      }
      .value {
        color: red;
        > div {
          border-bottom: 1px solid #ccc;
          display: flex;
          > span {
            width: 25%;
            font-size: 12px;
            font-weight: 400;
            border-right: 1px solid #ccc;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #555;
          }
          > div {
            padding: 6px 12px;
            background-color: #000;
            display: flex;
            flex-wrap: wrap;
            grid-gap: 12px;
            justify-content: center;
            flex: 1;
            color: red;
            .win {
              background-color: #fcfb04;
              font-size: 120%;
            }
          }
          .kaijiang {
            background-color: #fff;
            width: 120px;
            padding: 6px 0;
            flex: 0.5;
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            color: red;
            text-align: center;
            color: #555;
            font-size: 12px;
            font-weight: 400;
            align-items: center;
          }
        }
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
    }
    .li_win {
      .winText {
        color: #d00880;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
</style>